<template>
  <CardComponent class="top-list" ref="topList">
    <div class="title-row d-flex justify-space-between">
      <div class="title-col-left">
        <span class="title-category">{{ titleCategory }}</span>
        <span class="title-text">{{ title }}</span>
      </div>

      <span class="menu-icon" @click="showDropdown = !showDropdown">&vellip;</span>
      <div
        class="top-list-dropdown"
        :class="{show: showDropdown, 'position-left': dropdownPositionLeft}"
        v-click-outside="{
        handler: () => {showDropdown = false},
        closeConditional: () => showDropdown
      }">
        <slot :closeDropdown="closeDropdown"></slot>
      </div>
    </div>
    <div class="list-row">
      <div class="list-item d-flex justify-space-between" v-for="(item, index) in list" :key="index">
        <span class="list-item-text" :class="{first: index === 0}">{{index + 1}}. {{ item.text }}</span>
        <span class="list-item-trend">{{ item.trendText }}
          <component v-bind="iconProps(item.trendIconColor)"
                     :is="trendIconName(item.trendDirection)"/></span>
      </div>
    </div>
    <div class="footer-row">
      <span class="interval">{{ interval }}</span>
      <span class="top-category">{{ category }}</span>
    </div>
  </CardComponent>
</template>

<script>
import {onMounted, ref} from "@vue/composition-api";
import CardComponent from "@/components/form/CardComponent";
import TrendDownIcon from "@/components/icons/TrendDownIcon";
import TrendUpIcon from "@/components/icons/TrendUpIcon";
import NoTrendIcon from "@/components/icons/NoTrendIcon";

const trendDirections = {
  UP: 0,
  DOWN: 1,
  FLAT: 2
}

const colors = {
  GREEN: 0,
  RED: 1,
  GRAY: 2
}

export default {
  name: "TopListComponent",
  components: {NoTrendIcon, TrendUpIcon, TrendDownIcon, CardComponent},
  props: {
    titleCategory: String,
    title: String,
    interval: String,
    category: String,
    list: {
      type: Array,
      default: () => []
    }
  },
  setup(_, {refs}) {

    const dropdownPositionLeft = ref(false)
    onMounted(() => {
      function setDorpdownPosition(){
        let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        let dropdownRigth = refs.topList.$el.getBoundingClientRect().right + 172
        dropdownPositionLeft.value = vw < dropdownRigth
      }
      setDorpdownPosition()
      window.addEventListener('resize', setDorpdownPosition)
    })

    function trendIconName(direction) {
      switch (direction) {
        case trendDirections.UP:
          return 'TrendUpIcon'
        case trendDirections.DOWN:
          return 'TrendDownIcon'
        case trendDirections.FLAT:
          return 'NoTrendIcon'
      }
    }

    function iconProps(color) {
      switch (color) {
        case colors.RED:
          return {red: true}
        case colors.GREEN:
          return {green: true}
        case colors.GRAY:
          return {gray: true}
      }
    }

    const showDropdown = ref(false)

    function closeDropdown() {
      showDropdown.value = false
    }

    return {trendIconName, iconProps, showDropdown, closeDropdown, dropdownPositionLeft}
  }
}

export {trendDirections, colors}
</script>

<style scoped lang="scss">
.top-list {
  color: map-get($grey, 'lighten-blue-1');
  font-size: 17px;
  display: flex;
  flex-direction: column;
  padding: 8px 12px 6px;
  width: 460px;
  min-height: 160px;

  .title-row {
    .title-category {
      font-weight: 500;
      padding-right: 0.25rem;
    }

    .menu-icon {
      cursor: pointer;
      font-size: 26px;
      line-height: 26px;
      padding: 0;
    }

    .top-list-dropdown {
      position: absolute;
      top: 8px;
      left: calc(100% - 8px);
      z-index: 1;
      background-color: white;
      border-radius: 5px;
      box-shadow: 0 6px 10px rgba(0, 0, 0, 0.16);
      display: none;
      overflow: hidden;
      width: 180px;

      &.position-left {
        left: auto;
        right: 22px;
      }

      &.show {
        display: flex;
      }

      .dropdown-wrapper {
        width: 100%;

        .dropdown-action {
          border-bottom: 1px solid map-get($grey, 'lighten-blue-1');
          display: block;
          cursor: pointer;
          font-size: 14px;
          padding: 16px;
          transition: all 0.2s ease-in-out;;
          width: 100%;

          &:last-child {
            border: none;
          }

          &:hover {
            background-color: map-get($green, 'lighten-5');
            color: map-get($grey, 'dark');
          }

          .dropdown-action-text {
            margin: auto;
          }
        }
      }
    }
  }

  .list-row {
    color: map-get($grey, 'darken-1');
    font-size: 16px;
    line-height: 24px;
    padding-top: 8px;

    .list-item {
      .list-item-text {
        &.first {
          font-weight: bold;
        }
      }

      .list-item-trend {
        font-size: 14px;
        white-space: nowrap;

        svg {
          margin-left: 4px;
        }
      }
    }
  }

  .footer-row {
    position: relative;
    font-size: 14px;
    margin-top: auto;
    padding-top: 6px;

    &::before {
      position: absolute;
      top: 0;
      left: -12px;
      right: -12px;
      border-top: 1px solid map-get($grey, 'lighten-blue-1');
      content: '';
    }

    .top-category {
      float: right;
    }
  }
}
</style>
